import React, { useCallback, useMemo } from 'react';
import { View, TouchableOpacity, Platform } from 'react-native';
import Text from 'design-system/Text';
import { hitSlopS, rem } from 'design-system/values';
import links from 'utils/links';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import IconDownload from '../icons/IconDownload';
import IconStatement from '../icons/IconStatement';
import { STOCK_ICON_SIZE, ROW_ITEM_HORIZONTAL_PADDING, ROW_ITEM_VERTICAL_PADDING } from '../constants';
import webActivityRowStyle from './webActivityRowStyle';
import { isWeb } from '../../../constants';
const strings = {
    statement: 'Statement',
};
const StatementActivityItem = ({ item, isFirstInSection, isLastInSection, withWrapper }) => {
    const navigation = useMainStackNavigation();
    const styles = useStyles(styleSet);
    const onDownload = useCallback(() => {
        if (item.url) {
            if (Platform.OS === 'android') {
                navigation.navigateDeprecated('Pdf', {
                    url: item.url,
                    withTopPadding: true,
                    fileName: `Emma_trading_activity_statement_${item.month}-${item.year}`,
                });
            }
            else {
                links.openLink(item.url);
            }
        }
    }, [item]);
    const borderStyles = useMemo(() => [styles.wrapper, isFirstInSection && styles.firstItem, isLastInSection && styles.lastItem], [styles.wrapper, styles.firstItem, styles.lastItem, isFirstInSection, isLastInSection]);
    const webRowStyle = withWrapper ? webActivityRowStyle : undefined;
    return (<View style={withWrapper ? borderStyles : null}>
      <View style={webRowStyle ? [styles.itemContainer, webRowStyle] : styles.itemContainer}>
        <View style={styles.iconContainer}>
          <IconStatement size={STOCK_ICON_SIZE}/>
        </View>
        <View style={styles.infoContainer}>
          <View style={styles.infoRow}>
            <Text Text-16 flex numberOfLines={1}>
              {strings.statement}
            </Text>
          </View>
          <View style={styles.infoRow}>
            <Text TextThin-14 Gray flex>
              {item.month} {item.year}
            </Text>
          </View>
        </View>
        <TouchableOpacity onPress={onDownload} hitSlop={hitSlopS}>
          <IconDownload />
        </TouchableOpacity>
      </View>
    </View>);
};
const ICON_CONTAINER_SIZE = rem(STOCK_ICON_SIZE);
const styleSet = createStyleSheets((colors) => ({
    itemContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: rem(ROW_ITEM_HORIZONTAL_PADDING),
        paddingVertical: rem(ROW_ITEM_VERTICAL_PADDING),
        // On web the card is padded by 8 and each row by 8, like the other activity rows
        ...(isWeb && { paddingHorizontal: rem(8) }),
    },
    iconContainer: {
        width: ICON_CONTAINER_SIZE,
        height: ICON_CONTAINER_SIZE,
        marginRight: rem(16),
        alignItems: 'center',
        justifyContent: 'center',
    },
    infoContainer: { flex: 1 },
    infoRow: { flexDirection: 'row', alignItems: 'center' },
    wrapper: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
        ...(isWeb && { paddingHorizontal: rem(8) }),
    },
    firstItem: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
        ...(isWeb && { paddingTop: rem(8) }),
    },
    lastItem: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
        ...(isWeb && { paddingBottom: rem(8) }),
    },
}));
export default StatementActivityItem;
